import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DeleteModal from "./DeleteModal";
import GenericModal from "./GenericModal";
import ModalAdminvendorsonhome from "./ModalAdminvendorsonhome";
import ModalAdminvendorsonhomeup from "./ModalAdminvendorsonhomeup";
import Navbar from "./Navbar";
import {
  deleteVendorsOnHome,
  fetchVendorsonhomeItems,
} from "./redux/slices/VendorsonhomeThunks";
import { fetchVendorItems } from "./redux/slices/VendorThunks";

export default function Adminvendorshomeone() {
  const dispatch = useDispatch();
  const vendor_home = useSelector((state) => state.vendorsonhome.items);
  const vendors = useSelector((state) => state.vendor.items);
  const [vendorIds, setVendorIds] = useState([]);
  const [showData, setShowData] = useState([]);
  const [allShowData, setAllShowData] = useState([]);
  const [tableColumn, setTableColumn] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [active, setActive] = useState();
  const [search, setSearch] = useState("");

  const openModal = () => setIsModalOpen(true);
  const closeModal = async () => {
    await getVendorHome();
    setIsModalOpen(false);
  };
  const openEditModal = (type, item) => {
    setActive(item);
    setIsUpdateModalOpen(true);
  };
  const closeEditModal = async () => {
    await getVendorHome();
    setIsUpdateModalOpen(false);
  };

  const openDeleteModal = (item) => {
    setActive(item);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = async () => {
    await getVendorHome();
    setIsDeleteModalOpen(false);
  };

  const deleteClick = async () => {
    await dispatch(deleteVendorsOnHome(active));
    closeDeleteModal();
  };

  useEffect(() => {
    if (allShowData.length > 0) {
      const filtered = allShowData.filter((val) =>
        val.name.toLowerCase()?.includes(search.toLowerCase())
      );

      setShowData(filtered);
    }
  }, [search, vendor_home]);

  useEffect(() => {
    if (vendor_home.length > 0) {
      const tableColumns = [
        { key: "name", width: "25%" },
        { key: "position", width: "25%" },
        { key: "badge", width: "25%" },
        { key: "faq_action", width: "25%" },
      ];

      const tableData =
        vendor_home.length > 0
          ? vendor_home.map((val, idx) => {
              const vendor = vendors.find((value) => {
                return val.vendor_id == value._id;
              });
              return {
                _id: val?._id,
                name: vendor?.vendor_firstname
                  ? vendor?.vendor_firstname + " " + vendor?.vendor_lastname
                  : "",
                position: val.position ? val.position : "",
                badge: vendor?.vendor_badge ? vendor?.vendor_badge : "",
              };
            })
          : [];
      setTableColumn(tableColumns);
      setShowData(tableData);
      setAllShowData(tableData);
    } else {
      setShowData([]);
      setAllShowData([]);
    }
  }, [vendor_home, vendors]);

  useEffect(() => {
    if (vendors.length > 0) {
      var arr = [];
      var obj = {};
      vendors.map((val, idx) => {
        obj.label = val.vendor_firstname + " " + val.vendor_lastname;
        obj.value = val._id;
        arr.push(obj);
      });
      setVendorIds(arr);
    }
  }, [vendors]);

  const getVendorHome = () => {
    try {
      dispatch(fetchVendorItems());
      dispatch(fetchVendorsonhomeItems());
      const tableHeaders = [
        { label: "Vendor Name", width: "25%" },
        { label: "Position", width: "25%" },
        { label: "Badge", width: "25%" },
        { label: "Action", width: "40%" },
      ];
      setTableHeader(tableHeaders);
    } catch (e) {
      console.log(e, "error");
    }
  };

  useEffect(() => {
    getVendorHome();
  }, []);

  return (
    <RootWrapperAdminvendorshomeone>
      <Navbar />
      <Dashboard>
        <Wrapper>
          <Left_0001>
            <PRTNR.SidebarNav />
          </Left_0001>
          <Right>
            <DashboardHeader>
              <Frame1462>
                <WelcomeJames>Vendors on Home</WelcomeJames>
              </Frame1462>
              <Frame1461>
                <AIMEButton
                  size="small"
                  onClick={() => {
                    openModal();
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    gap: "10px",
                    borderRadius: "48px",
                    background: "rgb(33, 37, 67)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    Add
                  </span>
                </AIMEButton>
              </Frame1461>
            </DashboardHeader>
            <ContentBox>
              <TableTitle>
                <Frame1431>
                  <Title>All</Title>
                </Frame1431>
                <Frame1432>
                  <GFieldsStacked>
                    <GFieldsStacked_0001>
                      <PRTNR.Input
                        type="text"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </GFieldsStacked_0001>
                  </GFieldsStacked>
                </Frame1432>
              </TableTitle>
              <PRTNR.TableComponent
                data={showData}
                tableColumn={tableColumn}
                tableHeader={tableHeader}
                editClick={openEditModal}
                deleteClick={openDeleteModal}
              />
            </ContentBox>
          </Right>
        </Wrapper>
      </Dashboard>
      <Footer>
        <Section>
          <Section_0001>
            <Wrapper_0001>
              <Frame38>
                <_2025PaartnerLimitedAllRightsReserved>
                  © 2025 Paartner Limited. All Rights Reserved
                </_2025PaartnerLimitedAllRightsReserved>
              </Frame38>
            </Wrapper_0001>
          </Section_0001>
        </Section>
      </Footer>
      <GenericModal isOpen={isModalOpen} onClose={closeModal}>
        <ModalAdminvendorsonhome
          isOpen={isModalOpen}
          onClose={closeModal}
          vendorIds={vendorIds}
        />
      </GenericModal>
      <GenericModal isOpen={isUpdateModalOpen} onClose={closeEditModal}>
        <ModalAdminvendorsonhomeup
          isOpen={isUpdateModalOpen}
          onClose={closeEditModal}
          data={active}
        />
      </GenericModal>
      <GenericModal isOpen={isDeleteModalOpen} onClose={closeDeleteModal}>
        <DeleteModal
          isOpen={isDeleteModalOpen}
          onDelete={deleteClick}
          itemName={"Vendor from home page"}
        />
      </GenericModal>
    </RootWrapperAdminvendorshomeone>
  );
}

const RootWrapperAdminvendorshomeone = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Dashboard = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 1200px;
  box-sizing: border-box;
  padding: 32px 0px;
`;

const Left_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  width: 298px;
  box-sizing: border-box;
`;

const Right = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 878px;
  box-sizing: border-box;
`;

const DashboardHeader = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1462 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 772px;
  box-sizing: border-box;
`;

const WelcomeJames = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: center;
`;

const Frame1461 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const ContentBox = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  width: 878px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
`;

const TableTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1431 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Title = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Frame1432 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  width: 782px;
  box-sizing: border-box;
`;

const GFieldsStacked = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-sizing: border-box;
`;

const GFieldsStacked_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 4px;
  box-sizing: border-box;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Section = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Section_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame38 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const _2025PaartnerLimitedAllRightsReserved = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;
